module.exports = __webpack_public_path__ + "img/idme-logo.504331be.svg";